module.exports = __webpack_public_path__ + "static/img/noData.e0cdefe9.png";